import apiMaintenanceSchedule from 'services/inventory/maintenance-schedule'

export const handleSave = async (values: any) => {
  let res = await apiMaintenanceSchedule.createAction(values)

  return res?.data?.success
}
